/* eslint-disable no-new */
import Marionette from "backbone.marionette";
import Validation from "backbone-validation";
import qs from "query-string";
import Backbone from "backbone";
import AnimatedRegion from "marionette-animated-region";
import Cleave from "cleave.js";
import $ from "jquery";
import _defaults from "lodash/defaults";
import _debounce from "lodash/debounce";
import _throttle from "lodash/throttle";
import moment from "moment-timezone";
import cookie from "js-cookie";

import { LONG_ANSWER_CHARS, RESUME_STORAGE_KEY, SUGGESTION_SOURCE } from "lib/constants";
import { heapTrack } from "lib/analytics";
import { isZipNearPositions } from "lib/position";
import wsStorage from "lib/wsStorage";

import config from "../config";
import tmpl from "../templates/steps";
import item from "../models/item";
import positionModels from "../models/positions";
import modelUtil from "../models/util";
import component from "../components";
import util from "../util";
import auth from "../components/auth";
import events from "../events";
import rollbar from "../rollbar";
import LocationDialog from "../components/locationDialog";
import Warning from "../components/warning";

import { ResumeUpload, ResumeUploadModal } from "./app/resume";
import { ResumeReminderModal } from "./app/reminder";
import { BaseStep as Step } from "./app/step/base";
import AddJobStep from "./app/step/add-job";
import { GapItemView, JobItemView } from "./app/step/work-history";
import { GutCheck, isGutCheckTest, showModal } from "./app/util";
import { saveSuggestion } from "./suggestion";

util.bindValidation();

const PromoStep = Step.extend({
    name: "STEP_PROMO",
    template: tmpl.Promo,
    ui: {
        promo: "#self-promo",
        promoCount: "#promo-char-count",
    },
    events: {
        "keyup @ui.promo": "updatePromoCount",
    },
    postRender() {
        $(".next-container").show();
    },
    shouldSkip() {
        const query = qs.parse(window.location.search);
        return (
            this.model.get("jobs").getJobs().length > 0 ||
            this.model.hasResumeReminder() ||
            query.from_sug
        );
    },
    updatePromoCount() {
        if (this.ui.promoCount.not(":visible")) {
            this.ui.promoCount.fadeIn();
        }

        if (!this.promoCharLimit) {
            this.promoCharLimit = this.ui.promo.prop("maxlength");
        }

        this.ui.promoCount.text(
            `Character limit: ${this.promoCharLimit - this.ui.promo.val().length}`,
        );
    },
    getData() {
        return {
            self_promo: this.ui.promo.val(),
        };
    },
});

const SummaryStep = PromoStep.extend({
    name: "STEP_SUMMARY",
    template: tmpl.Summary,
    shouldSkip() {
        return false;
    },
    postRender() {
        // Needs a delay because of the slide animation, it appears.
        setTimeout(() => {
            this.ui.promo.focus();
        }, 100);
    },
});

const AvailabilityStep = Step.extend({
    name: "STEP_AVAILABILITY",
    template: tmpl.Avail,
    ui: {
        availTable: "#availability",
        backBtn: ".btn-end-step",
    },
    events: {
        "click @ui.backBtn": "endStep",
    },
    endStep() {
        this.onDestroy();
        this.model.trigger("step:end");
    },
    getData() {
        return this.availComponent.getData();
    },
    postRender() {
        this.availComponent = new component.AvailabilityComponent({
            el: this.ui.availTable,
            data: this.model.getShiftPrefs(),
        });
        this.availComponent.render();
    },
    submit() {
        if (!this.availComponent.validate()) {
            return false;
        }

        return Step.prototype.submit.call(this);
    },
});

const SignUpStep = Step.extend({
    name: "STEP_SIGNUP",
    ui: {
        first: "#first_name",
        last: "#last_name",
        email: "#email",
        phone: "#phone",
        password: "#login-password",
        login: "#btn-login",
    },
    events: {
        "click @ui.login": "login",
        "click .js-phone-modal": "onShowPhoneModal",
    },
    login() {
        if (!this.loginView) {
            return;
        }

        if (this.ui.login.prop("disabled")) {
            return;
        }

        this.ui.login.disable();

        const promise = this.loginView.login();
        if (promise) {
            promise.done(this.onLoginSuccess.bind(this)).always(() => {
                this.ui.login.enable();
            });
        } else {
            this.ui.login.enable();
        }
    },
    getTemplate() {
        if (util.shouldShowLogin()) {
            events.trackVirtualPage("/app/step_login");
            return tmpl.LogIn;
        }
        return tmpl.SignUp;
    },
    getFeaturedPosition() {
        return window.positions.length === 1 && window.positions[0];
    },
    serializeData() {
        return _defaults(this.model.toJSON(), {
            isProfile: this.options.isProfile,
            isReview: this.options.isReview,
            isRegister: this.options.isRegister,
            first_name: null,
            last_name: null,
            email: (window.user && window.user.email) || null,
            phone: null,
            position: this.getFeaturedPosition(),
            url: this.getRedirectUrl(),
            authUser: window.authUser,
            handle: util.getQueryParam("usr"),
        });
    },
    getNextButton() {
        return this.$(".next-button");
    },
    getData() {
        return {
            first_name: $(this.ui.first).val(),
            last_name: $(this.ui.last).val(),
            email: $(this.ui.email).val(),
            phone: $(this.ui.phone).val().replace(/\D/g, ""),
        };
    },
    postRender() {
        if (util.shouldShowLogin()) {
            this.loginView = new component.LoginView({
                el: this.el,
                template: false,
            });
            this.loginView.render();
        }

        if (this.ui.phone.length) {
            new Cleave(this.ui.phone, config.cleave.PHONE_CONFIG);
        }
    },
    postDestroy() {
        $("#login-link").hide();
    },
    onLoginSuccess() {
        events.trackLoginEvent("good-password");
        setTimeout(() => {
            window.location = this.getRedirectUrl();
        }, 0);
    },
    onShowPhoneModal(event) {
        event.preventDefault();
        showModal($("#phone-number-modal"));
    },
    getRedirectUrl() {
        const query = qs.parse(window.location.search);
        delete query.usr;
        return `${window.location.pathname}?${qs.stringify(query)}`;
    },
});

const AddressStep = Step.extend({
    name: "STEP_ADDRESS",
    template: tmpl.Info,
    autocomplete: null,
    ui: {
        addressForm: ".address-form-group",
        address: "#address_line1",
        addressLine2: "#address_line2",
        addressCity: "#address_city",
        addressState: "#address_state",
        addressPostalCode: "#address_postal_code",
        addressInternational: "#address_international",
    },
    events: {
        "change @ui.address": "onAddressChanged",
        "change @ui.addressPostalCode": "onAddressChanged",
        "change @ui.addressInternational": "onInternationalChanged",
    },
    serializeData() {
        let data = this.model.toJSON();

        data = _defaults(data, {
            isProfile: this.options.isProfile,
            isReview: this.options.isReview,
            address_international: false,
            address_line1: null,
            address_line2: null,
            address_city: null,
            address_state: null,
            address_postal_code: null,
        });

        return data;
    },
    onAddressChanged() {
        this.checkLocation = true;
        this.runZipCheck = true;
    },
    onInternationalChanged() {
        this.toggleAddress();
        this.onAddressChanged();
    },
    toggleAddress() {
        if (this.ui.addressInternational.is(":checked")) {
            this.ui.addressForm.hide();
        } else {
            this.ui.addressForm.show();
        }
    },
    getPlace() {
        if (this.autocomplete) {
            return this.autocomplete.getPlace();
        }

        return null;
    },
    getData() {
        let latLng;

        if (this.autocomplete) {
            const place = this.getPlace();
            if (place && place.formatted_address) {
                if (place.geometry) {
                    latLng = place.geometry.location.toJSON();
                }
            }
        }

        const data = {
            address_line1: this.ui.address.val(),
            address_line2: this.ui.addressLine2.val(),
            address_city: this.ui.addressCity.val(),
            address_state: this.ui.addressState.val(),
            address_postal_code: this.ui.addressPostalCode.val(),
            address_international: this.ui.addressInternational.is(":checked"),
        };

        if (latLng) {
            data.lat_lng = latLng;
        }

        if (this.checkLocation !== null) {
            // We've actually checked their location
            if (this.checkLocation) {
                data.location_screen = false;
            } else {
                data.location_screen = true;
            }
        }

        return data;
    },
    validateAddress() {
        const zip = this.model.get("address_postal_code");

        if (this.runZipCheck && (!this.options.isProfile || this.options.isReview)) {
            isZipNearPositions(zip).then((success) => {
                this.runZipCheck = false;

                // If user doesn't have any nearby positions (within 100 miles) show "moving" modal
                if (this.ui.addressInternational.is(":checked") || !success) {
                    heapTrack("Application - Location Dialog Shown", {
                        zip,
                    });
                    const dialog = new LocationDialog({
                        el: $("#distance-modal"),
                        model: this.model,
                        isProfile: this.options.isProfile,
                    });
                    dialog.render();

                    this.listenTo(dialog, "complete", () => {
                        heapTrack("Application - Location Dialog Completed");
                        this.checkLocation = false;

                        this.finishValidation();
                    });
                } else {
                    this.finishValidation();
                }
            });

            return false;
        }

        return true;
    },
    finishValidation() {
        if (this.submit()) {
            if (this.options.isReview || this.options.isProfile) {
                this.save();
            } else {
                this.nextStep();
            }
        }
    },
    submit() {
        Validation.bind(this, {
            model: this.model,
        });

        const data = this.getData();
        const userValid = this.model.set(data, { validate: "partial" });

        if (userValid) {
            return this.validateAddress();
        }

        return false;
    },
    postRender() {
        this.checkLocation = null;
        this.runZipCheck = true;

        const address = this.ui.address[0];
        const onChange = this.fillAddressFields.bind(this);

        // this is necessary in the case that we loadApplication directly
        if (window.loaded) {
            window.initAutocomplete(address, {
                callback: (ac) => (this.autocomplete = ac),
                onChange,
            });
        } else {
            $(window).on("load", () => {
                window.initAutocomplete(address, {
                    callback: (ac) => (this.autocomplete = ac),
                    onChange,
                });
            });
        }

        this.toggleAddress();
    },
    fillAddressFields() {
        this.onAddressChanged();
        const place = this.getPlace();
        if (!place || !place.address_components) {
            return;
        }

        const addressFields = [
            [this.ui.address, ""],
            [this.ui.addressCity, ""],
            [this.ui.addressState, ""],
            [this.ui.addressPostalCode, ""],
        ];

        place.address_components.forEach((addressComponent) => {
            const addressType = addressComponent.types[0];
            addressFields.forEach((addressField) => {
                const addressComponents = addressField[0].data("addressComponents");
                if (addressComponents.indexOf(addressType) > -1) {
                    if (addressField[1].length !== 0) {
                        addressField[1] += " ";
                    }
                    addressField[1] += addressComponent.short_name;
                }
            });
        });

        addressFields.forEach((addressField) => {
            addressField[0].val(addressField[1]);
        });
    },
});

const BasicInfoStep = AddressStep.extend({
    name: "STEP_INFO",
    template: tmpl.Info,
    ui: {
        dob: "#birth_date",
        name: "#name",
        degreeMajor: "#degree_major",
        nameContainer: "#name_container",
        majorContainer: "#degree_major_container",
        degree: "#degree_type",
        eligible: "#eligible",
        ethnicity: "#ethnicity",
        gender: "#gender",
        promo: "#self-promo",
        veteranStatus: "#veteran_status",
        disabilityStatus: "#disability_status",
    },
    events: {
        "click .js-vet-modal": "onShowVetModal",
        "click .js-dis-modal": "onShowDisabilityModal",
        "change @ui.degree": "showNameAndOrMajor",
    },
    onShowVetModal(event) {
        event.preventDefault();

        $("#veteran-status-modal").modal({
            closeClass: "icon-close",
            closeText: "&times;",
            fadeDuration: 350,
            fadeDelay: 0,
        });
    },
    onShowDisabilityModal(event) {
        event.preventDefault();

        $("#disability-status-modal").modal({
            closeClass: "icon-close",
            closeText: "&times;",
            fadeDuration: 350,
            fadeDelay: 0,
        });
    },
    showNameAndOrMajor() {
        const value = $(this.ui.degree).val();
        if (value != 0 && value != 6) {
            this.ui.nameContainer.fadeIn();
        } else {
            this.ui.nameContainer.fadeOut();
        }

        if (value > 1 && value != 6) {
            this.ui.majorContainer.fadeIn();
        } else {
            this.ui.majorContainer.fadeOut();
        }
    },
    serializeData() {
        let data = AddressStep.prototype.serializeData.call(this);
        const schools = this.model.get("schools");
        if (schools.length) {
            data = _defaults(data, schools.last().toJSON());
        }

        if (data.birth_date) {
            data.birth_date = moment.utc(data.birth_date).format("MMDDYYYY");
        }

        data.veteran_status = this.model.get("veteran_status");
        data.disability_status = this.model.get("disability_status");

        data = _defaults(data, {
            degree_type: 0,
            name: null,
            degree_major: null,
            birth_date: null,
            gender: null,
            ethnicity: null,
            eligible: null,
            veteran_status: null,
            disability_status: null,
        });

        return data;
    },
    getData() {
        let data = AddressStep.prototype.getData.call(this);

        if (!this.options.isProfile || this.options.isReview) {
            const dob = this.ui.dob.val();
            data = {
                ...data,
                birth_date: dob.length === 10 ? moment.utc(dob, "MMDDYYYY") : null,
                eligible: this.ui.eligible.val(),
                ethnicity: this.ui.ethnicity.val(),
                gender: this.ui.gender.val(),
                veteran_status: Number(this.ui.veteranStatus.val()),
                disability_status: Number(this.ui.disabilityStatus.val()),
            };
        }

        return data;
    },
    submit() {
        if (!this.school) {
            this.school = new item.School();
        }
        Validation.bind(this, {
            model: this.school,
        });
        const school = {
            degree_type: this.ui.degree.val(),
        };
        if (this.ui.name.is(":visible")) {
            school.name = this.ui.name.val();
        }
        if (this.ui.degreeMajor.is(":visible")) {
            school.degree_major = this.ui.degreeMajor.val();
        }
        const schoolValid = this.school.set(school, { validate: "partial" });
        if (schoolValid) {
            this.model.get("schools").pop();
            this.model.get("schools").push(this.school);
        }
        Validation.bind(this, { model: this.model });

        const data = this.getData();
        const userValid = this.model.set(data, { validate: "partial" });

        if (schoolValid && userValid) {
            return this.validateAddress();
        }
        return false;
    },
    postRender() {
        if (this.ui.dob.length) {
            new Cleave(this.ui.dob, config.cleave.DATE_CONFIG);
        }

        this.showNameAndOrMajor();

        AddressStep.prototype.postRender.call(this);
    },
});

const EmptyView = Marionette.View.extend({
    template: false,
    render() {
        this.$el.html("No items listed yet");
        this.$el.addClass("no-items");
        return this;
    },
});

const CompositeStep = Marionette.CompositeView.extend({
    className: "form-step",
    modal: null,
    addStep: null,
    ui: {
        addButton: ".add-button",
        backBtn: ".btn-end-step",
        saveBtn: ".save-changes",
    },
    events: {
        "click @ui.addButton": "onOpenModal",
        "click @ui.backBtn": "endStep",
        "click @ui.saveBtn": "onSave",
    },
    initialize(...args) {
        this.onNext = this.onNext.bind(this);
        this.onRegionShown = this.onRegionShown.bind(this);

        this.postInit(...args);
    },
    postInit() {},
    onRegionShown(region) {
        // animated region's transforms mess up position: fixed elements
        region.$el.css("transform", "none");
        this.afterRegionShown(region);
    },
    afterRegionShown() {},
    onSave(e) {
        e.preventDefault();

        this.save();
    },
    save() {
        if (this.submit()) {
            this.ui.saveBtn.prop("disabled", true);
            this.ui.saveBtn.siblings(".loader").show();
            this.onDestroy();
            this.model.trigger("step:end", true);
            this.closeModal();
        }
    },
    attachElContent(html) {
        if (this.options.isProfile) {
            html += tmpl.Btns();
        }

        this.$el.html(html);
        return this;
    },
    endStep() {
        this.onDestroy();
        this.model.trigger("step:end");
    },
    onOpenModal(e) {
        e.preventDefault();
        this.openModal();
    },
    openModal(_model) {
        this.modal = this.addStep.render(_model);
        this.listenTo(this.modal, "modal:close", this.closeModal);
        this.listenTo(this.modal, "modal:save", () => {
            this.addItem();
        });
    },
    shouldSkip() {
        return false;
    },
    closeModal() {
        if (this.modal) {
            this.stopListening(this.modal);
            this.modal.$el.hide();
        }
        $.modal.close();
        this.modal = null;
    },
    onRender() {
        const self = this;
        Backbone.Radio.channel("region").on("region:shown", this.onRegionShown);
        if (this.name) {
            $(".application.content").addClass(this.name.toLowerCase());
        }

        Validation.bind(self);
        this.listenTo(this.getCollection(), "remove", () => {
            $(this.ui.addButton).show();
        });

        this.listenTo(this.model, "step:next", this.onDestroy);
        this.bindNextStep();

        this.createAddStep();
        this.postRender();
    },
    onDestroy() {
        this.bound = false;
        $(".next-button").unbind(`click.${this.cid}`);
        this.stopListening(this.model);
        this.closeModal();
        Backbone.Radio.channel("region").off("region:shown", this.onRegionShown);
        if (this.name) {
            $(".application.content").removeClass(this.name.toLowerCase());
        }
        this.postDestroy();
    },
    bindNextStep() {
        if (this.bound) {
            return;
        }

        this.bound = true;
        $(".next-button").bind(`click.${this.cid}`, this.onNext);
    },
    onNext(event) {
        event.preventDefault();

        if (this.options.isProfile) {
            this.save();
            this.postNext();
        }

        if (this.submit(event)) {
            this.model.trigger("step:next");
            $.modal.close();
            this.postNext();
        }
    },
    createAddStep() {},
    postNext() {},
    postRender() {},
    postDestroy() {},
});

const GutCheckView = Marionette.View.extend({
    ui: {
        count: ".js-gut-check-count",
        counter: ".gut-check__counter",
        section: ".gut-check__section",
        nextBtn: ".js-gut-check-next",
        noBtn: ".js-gut-check-no",
        yesBtn: ".js-gut-check-yes",
        outroRec: ".js-gut-check-outro-recommend",
        outroComp: ".js-gut-check-outro-complete",
    },
    events: {
        "click @ui.nextBtn": "onNext",
        "click @ui.noBtn": "onNo",
        "click @ui.yesBtn": "onYes",
    },
    getTemplate() {
        if (isGutCheckTest()) {
            return tmpl.HistoryGutCheckIntro;
        }

        return tmpl.HistoryGutCheck;
    },
    initialize() {
        this.counter = this.options.hideIntro ? 1 : 0;
        this.gutCheck = new GutCheck(this.model);
    },
    shouldSkip() {
        const missingKeywords = this.gutCheck.isMissingKeywords();

        if (isGutCheckTest()) {
            return !missingKeywords || this.options.isProfile || this.options.isReview;
        }

        return !missingKeywords || this.gutCheck.getJobs().length >= 2;
    },
    serializeData() {
        const data = {
            showIntro: !this.options.hideIntro,
            skill: null,
            keywords: [],
            totalSteps: this.getCount(),
        };

        if (this.gutCheck.isMissingExperience()) {
            const { highestSkill } = this.gutCheck;
            const answer = highestSkill.getAnswerFromResponse();
            let total = "";

            const months = this.experienceMonths % 12;
            const years = Math.floor(this.experienceMonths / 12);

            if (years > 0) {
                total += `${years} year${years > 1 ? "s" : ""}`;
            }

            if (months > 0) {
                total += ` ${months} month${months > 1 ? "s" : ""}`;
            }

            data.skill = {
                experience: answer.value,
                keyword: highestSkill.getKeywords().slice().shift(),
                total,
            };
        }

        if (this.gutCheck.isMissingKeywords()) {
            data.keywords = this.gutCheck.getPrimaryKeywords();
        }

        return data;
    },
    next() {
        const $next = this.visibleSection.next();
        if ($next.length > 0) {
            this.counter += 1;

            this.visibleSection.fadeOut("fast", () => {
                const isIntro = $next.hasClass("gut-check__section--intro");
                const isOutro = $next.hasClass("gut-check__section--outro");

                if (isOutro) {
                    const shouldRecommend = $next.find("[data-keyword]").length > 0;
                    this.ui.outroRec.toggle(shouldRecommend);
                    this.ui.outroComp.toggle(!shouldRecommend);

                    // lol this is dumb
                    const $btn = this.getNextButton();
                    if (shouldRecommend) {
                        $btn.text("I'm done updating");
                    }

                    $btn.addClass("next-button--fixed").fadeIn();

                    $(".js-history-btn")
                        .removeClass("btn--disabled")
                        .off("click", this.preventClick);
                    $(".js-history-link").fadeIn();
                    $(".job-content").removeClass("job-content--disabled");
                }

                this.visibleSection = $next.fadeIn("fast");
                this.ui.counter.toggle(!(isIntro || isOutro));
                this.ui.count.text(this.counter);
            });
        }
    },
    onNext(event) {
        event.preventDefault();

        if (isGutCheckTest()) {
            this.trigger("gut-check-step", event);
            return;
        }

        this.next();
    },
    onNo(event) {
        event.preventDefault();
        this.next();
    },
    onYes(event) {
        event.preventDefault();

        const keyword = $(event.target).data("keyword");
        this.$(`[data-keyword="${keyword}"]`).remove();
        this.next();
    },
    getCount() {
        let count = 0;

        if (this.gutCheck.isMissingExperience()) {
            count += 1;
        }
        if (this.gutCheck.isMissingKeywords()) {
            count += this.gutCheck.getPrimaryKeywords().length;
        }

        return count;
    },
    onRender() {
        this.visibleSection = this.ui.section.first().show();
        this.getNextButton().fadeOut();
        $("html, body").animate({ scrollTop: 0 }, 0);

        this.preventClick = this.preventClick.bind(this);
        $(".js-history-btn").addClass("btn--disabled").on("click", this.preventClick);
        $(".js-history-link").fadeOut();
        $(".job-content").addClass("job-content--disabled");

        if (!isGutCheckTest()) {
            heapTrack("Gut Check - Control Shown");
        }
    },
    getNextButton() {
        return $(".app__history-next-container .js-next");
    },
    preventClick(event) {
        event.preventDefault();
        event.stopPropagation();
    },
});

function isResumeReminderTest() {
    // const uid = (window.heap && window.heap.identity) || cookie.get('_ws_heap') || window.uid;
    // return !window.complete && Number(uid) % 2 === 1;
    return false;
}

const HistoryStep = CompositeStep.extend({
    name: "STEP_HISTORY",
    emptyView: EmptyView,
    childView(_model) {
        if (_model.isGap()) {
            return GapItemView;
        }

        return JobItemView;
    },
    childViewContainer: "#work-experience",
    template: tmpl.History,
    ui: {
        companyName: ".js-company-name",
        failedParse: ".failed-parse",
        history: ".app__history-content",
        historyTypes: "[name=history-type]",
        inlineAdd: ".app__history-inline-add",
        inlineAddJob:
            ".app__history-inline-add:not(.app__history-inline-add--with-tip) .job-description",
        intro: ".app__history-intro:first-child",
        nextContainerRelative: ".app__history-next-container",
        resume: ".js-resume",
        resumeIntro: ".app__history-intro--resume",
        resumeModal: "#resume-modal",
        resumeReminderModal: "#resume-reminder-modal",
        successParse: ".success-parse",
        uploadResume: "#work-upload-resume",
        warning: ".app-warning-icon",
        workExperience: "#work-experience",
    },
    events: {
        "click .js-next": "onNext",
        "click .js-manual": "onManual",
        "click @ui.uploadResume": "onShowUploadResumeModal",
        "click @ui.inlineAddJob": "onClickInlineAdd",
    },
    isResumeReturn: false,
    hasChanges: false,
    shouldSkip() {
        // Since ws-suggest will hard reload the page, we just
        // wanna skip over this section if it was gonna show it again
        const query = qs.parse(window.location.search);
        return !!query.from_sug;
    },
    serializeData() {
        const data = this.model.toJSON();

        data.resumeReturn = this.isResumeReturn;
        data.positions = window.positions.slice(0, 2);
        data.positionCount = window.positions.length - 2;

        return data;
    },
    postInit() {
        this.triggerSave = _debounce(
            () => {
                this.model.trigger("step:save");
            },
            {
                leading: true,
                trailing: false,
            },
            1200,
        );

        this.isApp = !(this.options.isReview || this.options.isProfile);
        this.passedIntro = !this.isApp;
        this.toastShown = !this.isApp;
        this.tooltipShown = this.getJobs().length > 0;

        const query = qs.parse(window.location.search);
        this.showJobModal = !!query.br;

        const triedParse = wsStorage.getItem(RESUME_STORAGE_KEY);
        this.isResumeReturn =
            !window.complete && !this.showJobModal && !triedParse && this.model.hasResumeReminder();
    },
    postRender() {
        const isTest = isResumeReminderTest();
        heapTrack("WH Resume Reminder Test", {
            isTest,
            isReturning: this.isResumeReturn,
        });

        // History step uses its own 'relative' container
        $(".next-container").hide();

        // render resume modal only once on page load
        this.resumeModal = new ResumeUploadModal({
            model: this.model,
            isProfile: this.options.isProfile,
            isReview: this.options.isReview,
            el: this.ui.resumeModal,
        });
        this.resumeModal.render();
        this.listenTo(this.resumeModal, "start-resume-parse", this.saveStep);

        this.reminderModal = new ResumeReminderModal({
            el: this.ui.resumeReminderModal,
        });

        this.listenTo(this.reminderModal, "success", (resumeReminder) => {
            this.model.setResumeReminder(resumeReminder);
            this.skipStep();
        });
        this.listenTo(this.reminderModal, "manual", this.showFirstJobModal);
        this.listenTo(this.reminderModal, "skip", () => {
            this.model.setResumeReminder("skip");
            this.skipStep();
        });

        this.updateUI({ isRender: true });

        if (this.showJobModal) {
            this.showFirstJobModal();
            this.ui.historyTypes.filter("[value=reminder]").prop("checked", true);
        }

        const count = this.getJobs().length;
        const triedParse = wsStorage.getItem(RESUME_STORAGE_KEY);
        if (triedParse) {
            if (count > 0) {
                this.ui.successParse.css("display", "block");
                this.updateGaps();
            } else {
                // did a resume parse happen but not succeed?
                this.ui.intro.hide();
                this.ui.history.show();
                this.passedIntro = true;

                this.ui.failedParse.css("display", "block");
            }
        } else if (this.isResumeReturn) {
            this.resumeUpload = new ResumeUpload({
                el: this.ui.resume,
                model: this.model,
            });
            this.listenTo(this.resumeUpload, "start-resume-parse", this.saveStep);
            this.resumeUpload.render();

            this.ui.nextContainerRelative.hide();
        }

        if (this.isApp) {
            if (!this.passedIntro) {
                this.listenTo(this.resumeModal, "start-resume-parse", this.fadeIntro);
            }

            if (count > 0) {
                this.ui.intro.hide();
                this.ui.history.show();
                this.passedIntro = true;
                this.toastShown = true;
            }
        } else {
            this.ui.intro.hide();
            this.ui.nextContainerRelative.hide();
            this.ui.history.show();
        }
    },
    skipStep() {
        this.model.trigger("step:next");
        this.postNext();
    },
    postNext() {
        this.ui.nextContainerRelative.hide();
        // Ensure we show the next button when we're done
        $(".next-container").show();
    },
    postDestroy() {
        this.stopListening(this.getCollection());
        this.stopListening(this.addStep);

        if (this.warning) {
            this.warning.stop();
        }
    },
    attachElContent(html) {
        if (this.options.isProfile) {
            html += tmpl.HistoryBtns();
        }

        this.$el.html(html);
        return this;
    },
    createAddStep() {
        this.addStep = new AddJobStep({ el: "#history-modal" });

        this.listenTo(this.getCollection(), "edit", this.onItemEdit);
        this.listenTo(this.getCollection(), "add-job", this.onItemAddJob);
        this.listenTo(this.getCollection(), "save", this.saveStep);
        this.listenTo(this.getCollection(), "destroy", this.onItemDelete);
        this.listenTo(this.getCollection(), "add", this.onAdd);
        this.listenTo(this.getCollection(), "remove", this.onRemove);
    },
    onAdd(m) {
        if (m.get("title")) {
            this.updateUI({ isAdd: true });
        }
    },
    onRemove(m) {
        if (m.get("title")) {
            this.updateUI({});
        }
    },
    onManual(event) {
        event.preventDefault();

        this.ui.resumeIntro.fadeOut(() => {
            this.ui.intro.fadeIn();
            this.ui.nextContainerRelative.fadeIn();
            this.showFirstJobModal();
        });
    },
    updateUI({ isAdd = false, isRender = false }) {
        const count = this.getJobs().length;

        const empty = "app__history-inline-add--empty";
        const tooltip = "app__history-inline-add--with-tip";

        if (!this.isApp) {
            this.ui.inlineAdd.toggleClass(empty, count === 0);
            return;
        }

        if (count === 0) {
            this.ui.nextContainerRelative.show();
            this.ui.inlineAdd.addClass(empty).removeClass(tooltip);
        } else if (count === 1 && !this.tooltipShown) {
            // Only show the tooltip the first time they add their first job
            this.ui.nextContainerRelative.hide();
            this.ui.companyName.text(this.getJobs().at(0).get("company"));
            this.ui.inlineAdd.addClass(tooltip).removeClass(empty);
            this.tooltipShown = true;

            if (!isRender) {
                setTimeout(() => {
                    this.ui.inlineAdd[0].scrollIntoView({ behavior: "smooth" });
                }, 200);
            }
        } else {
            this.ui.nextContainerRelative.show();
            this.ui.inlineAdd.removeClass(tooltip).removeClass(empty);
            // Set this in case they uploaded a buncha jobs from a resume
            this.tooltipShown = true;

            if (isAdd) {
                setTimeout(() => {
                    this.ui.nextContainerRelative[0].scrollIntoView({ behavior: "smooth" });
                }, 200);
            }
        }
    },
    onNext(event) {
        if (!this.passedIntro) {
            event.preventDefault();

            const $type = this.ui.historyTypes.filter(":checked");
            if ($type.length === 0) {
                return;
            }

            let type = $type.val();
            if (!isResumeReminderTest() && type === "reminder") {
                type = "manual";
            }

            if (type === "upload") {
                this.onShowUploadResumeModal();
            } else if (type === "manual") {
                this.showFirstJobModal(true);
            } else if (type === "reminder") {
                this.reminderModal.render();
            } else if (type === "skip") {
                this.model.trigger("step:next");
            }

            return;
        }

        CompositeStep.prototype.onNext.call(this, event);
    },
    showFirstJobModal(first = false) {
        this.openModal(new item.Job({ first }));
    },
    onClickInlineAdd(event) {
        event.preventDefault();

        if (this.ui.inlineAdd.hasClass("app__history-inline-add--with-tip")) {
            return;
        }

        this.openModal();
    },
    onItemEdit(_model) {
        if (!_model.isGap()) {
            this.openModal(_model);
        }
    },
    onItemAddJob(_model) {
        const json = _model.toJSON();

        const job = new item.Job({
            start_date: json.start_date,
            end_date: json.end_date,
        });
        this.openModal(job);
    },
    onItemDelete() {
        this.updateGaps();
        this.saveStep();
    },
    addItem() {
        if (!this.passedIntro) {
            this.fadeIntro();
        }

        this.getCollection().add(this.modal.model);

        this.ui.failedParse.hide();
        this.modal.model.trigger("rerender");
        $.modal.close();

        this.updateGaps();
        this.saveStep();

        if (this.isApp) {
            const count = this.getJobs().length;
            if (count > 1 && !this.toastShown) {
                util.showToast(
                    $(
                        '<span class="app__history-toast">' +
                            "Awesome-you've added 2 jobs! Continue adding more jobs until this clearly shows all of your professional experience." +
                            "</span>",
                    ),
                    7000,
                );

                this.toastShown = true;
            }
        }
    },
    saveStep() {
        this.triggerSave();
        this.updateGaps();
        this.hasChanges = true;
    },
    getCollection() {
        return this.model.get("jobs");
    },
    getJobs() {
        return this.getCollection().getJobs();
    },
    getGaps() {
        return this.getCollection().getGaps();
    },
    endStep() {
        if (this.hasChanges) {
            this.save();
        } else if (this.submit()) {
            this.model.trigger("step:end");
        }
    },
    submit(e) {
        this.ui.failedParse.hide();

        const jobs = this.getJobs();

        let notValidJob = false;
        jobs.forEach((job) => {
            if (!job.get("complete_data")) {
                notValidJob = true;
            }
        });

        if (notValidJob) {
            $("#invalid-job-modal").modal({
                showClose: false,
                fadeDuration: 350,
                fadeDelay: 0,
            });
            return false;
        }

        if (!this.options.isProfile && !$.modal.isActive()) {
            if (!this.gutCheckShown && !jobs.length) {
                $("#blank-modal-job").modal({
                    closeClass: "icon-close",
                    closeText: "&times;",
                    fadeDuration: 350,
                    fadeDelay: 0,
                });
                return false;
            }

            const noMoreChoice = e && e.currentTarget.classList.contains("js-no-more-jobs");
            const months = jobs.getDuration();

            if (!noMoreChoice && !this.gutCheckShown && jobs.length < 3 && months < 24) {
                $("#light-workhistory-modal").modal({
                    closeClass: "icon-close",
                    closeText: "&times;",
                    fadeDuration: 350,
                    fadeDelay: 0,
                });
                return false;
            }
        }

        this.updateGaps();
        const gaps = this.getGaps();
        const unmarked = gaps.filter((g) => !g.get("reason") && !g.get("ignore"));

        if (!this.options.isProfile) {
            if (unmarked.length > 0) {
                // If they've said to skip all the gaps, just mark them ignored
                if (this.skipGapsShown) {
                    unmarked.forEach((gap) => {
                        gap.set("ignore", true);
                    });
                    this.updateGaps();
                    this.updateUI({ isRender: true });
                } else {
                    this.skipGapsShown = true;
                    $("#skip-gaps-modal").modal({
                        showClose: false,
                        fadeDuration: 350,
                        fadeDelay: 0,
                    });

                    return false;
                }
            }
        }

        if (this.gutCheckShown) {
            this.gutCheck.$el.fadeOut("fast", () => {
                this.gutCheck.destroy();
            });
        } else {
            this.gutCheckShown = true;
            this.updateUI({});

            const $div = $('<div class="gut-check"></div>');
            this.$el.parent().prepend($div);
            this.gutCheck = new GutCheckView({
                el: $div,
                model: this.model,
                isProfile: this.options.isProfile,
                isReview: this.options.isReview,
            });

            if (this.gutCheck.shouldSkip()) {
                $div.remove();
            } else {
                this.listenTo(this.gutCheck, "gut-check-step", this.onNext);
                this.gutCheck.render();
                $.modal.close();
                return false;
            }
        }

        const query = qs.parse(window.location.search);
        // ws-param should be deleted if it exists on successful job list save
        if (query[config.RESUME_GET_PARAM_FOR_RELOAD.KEY]) {
            delete query[config.RESUME_GET_PARAM_FOR_RELOAD.KEY];
            const newPath = `${window.location.pathname}?${qs.stringify(query)}`;
            window.history.pushState({}, "", newPath);
        }

        return true;
    },
    updateGaps() {
        this.getCollection().updateGaps();
        this.renderChildren();

        this.ui.successParse.hide();

        if (this.warning) {
            this.warning.recalculate();
        } else {
            this.warning = new Warning(this.ui.warning);
        }
    },
    onShowUploadResumeModal() {
        this.resumeModal.showModal();
    },
    fadeIntro() {
        $(".next-container").hide();

        this.ui.intro.fadeOut(100, () => {
            this.ui.history.fadeIn();
        });

        this.passedIntro = true;
        this.stopListening(this.resumeModal, "start-resume-parse", this.fadeIntro);
    },
});

function isSuggestTest() {
    // I am paused again.
    return false;
    // const uid = (window.heap && window.heap.identity) || cookie.get('_ws_heap');
    // return window.complete && Number(uid) % 2 === 0;
}

const SuggestionsStep = Step.extend({
    MAX_SUGGESTIONS: 8,

    name: "STEP_SUGGESTIONS",
    getTemplate() {
        if (isSuggestTest()) {
            return tmpl.SuggestionsTest;
        }

        return tmpl.Suggestions;
    },
    events: {
        "click .suggestions__pass": "onPass",
        "click .suggestions__approve": "onApprove",
        "click @ui.skip": "finishStep",

        // test
        "change @ui.positions": "onChangeSelection",
        "click .suggestion-row": "onClickRow",
        "click @ui.submitBtn": "onSubmit",
        "click .js-job-detail": "onClickDetails",
    },
    ui: {
        buttons: ".suggestions__buttons",
        skip: ".skip-suggestions",

        // test
        positions: "[name=positions]",
        selectedCount: ".suggestions__selected-count",
        submitBtn: ".suggestions__submit",
    },
    regions: {
        suggestions: {
            selector: ".suggestions__card",
            regionClass: AnimatedRegion,
            animation: {
                showAnimation: [
                    {
                        properties: "transition.slideRightBigIn",
                    },
                ],
                hideAnimation: [
                    {
                        properties: "transition.slideLeftBigOut",
                    },
                ],
            },
        },
    },
    postInit() {
        this.similar = [];
        this.approved = [];
        this.current = 0;

        const query = qs.parse(window.location.search);
        this.appPositions = query.p ? query.p.split(",") : [];

        this.processing = false;

        this.onDetailBack = this.onDetailBack.bind(this);
        this.onDetailShow = this.onDetailShow.bind(this);
        this.onPopState = this.onPopState.bind(this);
    },
    serializeData() {
        const max = isSuggestTest() ? 3 : this.MAX_SUGGESTIONS;

        return {
            count: Math.min(max, this.similar.length),
            suggestions: this.similar.slice(0, max), // For test only
        };
    },
    shouldSkip() {
        if (window.hasSuggestions || cookie.get("_skip_ws_suggest")) {
            return true;
        }

        this.similar = this.positions.getSimilarPositions();
        return this.similar.length === 0;
    },
    postRender() {
        const isTest = isSuggestTest();
        if (window.complete) {
            heapTrack("WS Suggest - Single-Click Test v2", { isTest });
        }

        $(".next-container").hide();

        const $body = $("body");
        $body.on("click", ".back", this.onDetailBack);
        $body.on("click", ".js-job-detail", this.onDetailShow);

        if (!isTest) {
            this.showSuggestion(0);
        }
    },
    afterRegionShown() {
        this.ui.buttons.fadeIn(100);
    },
    onClickRow(event) {
        // Meh, but avoid intercepting click to detail page
        if ($(event.target).closest(".js-job-detail").length) {
            return;
        }

        event.preventDefault();

        const $el = $(event.currentTarget);
        const $input = $el.find("input");
        $input.prop("checked", !$input.prop("checked"));

        this.selectRow($el);
    },
    onChangeSelection(event) {
        event.preventDefault();
        event.stopPropagation();
    },
    selectRow($row) {
        const count = this.ui.positions.filter(":checked").length;
        this.ui.selectedCount.text(count);

        const checked = $row.find("input").prop("checked");
        $row.toggleClass("suggestion-row--selected", checked);
    },
    onSubmit() {
        const positions = this.ui.positions
            .map((idx, el) => {
                const position = this.similar.filter((p) => p.id === Number(el.value)).pop();

                if (el.checked) {
                    this.approved.push(position.id);
                }

                return {
                    id: position.id,
                    accepted: el.checked,
                    index: this.similar.indexOf(position),
                    group: position.group,
                    source: SUGGESTION_SOURCE.APP,
                    app_positions: this.appPositions,
                    feature: position.suggestion_feature,
                };
            })
            .toArray();

        this.ui.submitBtn.loading(true);

        saveSuggestion({
            positions,
            appPositions: this.appPositions,
        })
            .catch(() => {
                rollbar.warn("Failed to save ws-suggest", {
                    uid: cookie.get("_ws_heap"),
                    positions,
                });
            })
            .then(() => {
                this.finishStep();
            });
    },
    onDetailShow() {
        this.detailShown = true;
        $("#app-container").addClass("detail-shown");
    },
    onDetailBack() {
        this.detailShown = false;
        $("#app-container").removeClass("detail-shown");
    },
    onPopState() {
        $(window).off("popstate", this.onPopState);
        this.showSuggestion(this.current);
    },
    getPosition() {
        const position = this.similar[this.current];
        if (!position) {
            rollbar.warn("Invalid index for ws-suggest", {
                index: this.current,
                listLength: this.similar.length,
            });
        }
        return position;
    },
    showSuggestion(index) {
        this.current = Math.min(this.similar.length, index);

        if (this.detailShown) {
            // Yay async operations. We need to wait for the popstate to happen because
            // we need the URL and querystring to NOT be the job detail URL
            $(window).on("popstate", this.onPopState);
            this.onDetailBack();
            window.goBack(true);
            return;
        }

        if (this.current >= Math.min(this.MAX_SUGGESTIONS, this.similar.length)) {
            this.finishStep();
            return;
        }

        const position = this.getPosition();
        if (!position) {
            this.finishStep();
            return;
        }

        this.card = new component.JobCard({
            model: new positionModels.Position(position),
        });
        this.showChildView("suggestions", this.card);

        this.processing = false;
    },
    finishStep() {
        const query = qs.parse(window.location.search);
        let positions = this.appPositions.slice();
        positions = positions.concat(this.approved);

        query.p = positions.filter(Boolean).join(",");
        query.sp = this.approved.join(",");

        const utm = cookie.get("utm") ? qs.parse(cookie.get("utm")) : {};
        utm.utm_medium = "ws-suggest";
        cookie.set("utm", qs.stringify(utm), { expires: 2 }); // days

        const url = `${window.location.pathname}?${qs.stringify(query)}`;

        if (this.approved.length) {
            // If we have new positions to add, use nextStep so the backend will
            // generate the applications
            window.history.pushState({}, "", url);
            this.nextStep();
        } else {
            // Otherwise, just reload to track that the choices were all "No"
            window.location = url;
        }
    },
    onApprove(event) {
        event.preventDefault();
        if (this.processing) {
            return;
        }

        const position = this.getPosition();
        if (position) {
            this.processing = true;
            this.approved.push(position.id);

            this.saveSuggestion(true);
        }

        this.card.showAdded(() => {
            this.showSuggestion(this.current + 1);
        });
    },
    onPass(event) {
        event.preventDefault();
        if (this.processing) {
            return;
        }

        this.processing = true;
        this.saveSuggestion(false);
        this.showSuggestion(this.current + 1);
    },
    saveSuggestion(accepted) {
        if (this.current === 3) {
            // Fourth suggestion
            this.ui.skip.fadeIn();
        }

        const position = this.getPosition();
        if (!position) {
            return;
        }

        saveSuggestion({
            accepted,
            index: this.current,
            group: position.group,
            source: SUGGESTION_SOURCE.APP,
            appPositions: this.appPositions,
            feature: position.suggestion_feature,
            positionID: position.id,
        });
    },
});

const ReviewStep = Step.extend({
    name: "STEP_REVIEW",
    template: tmpl.Review,
    ui: {
        avail: "#availability",
        enterPW: ".js-enter-pw",
        reminderSection: ".app-review__reminder",
        autoApplySection: ".app-review__auto-apply",
        reviewPWSection: ".review-password-modal",
        saveButton: ".js-save",
    },
    events: {
        "click [data-step]": "showStep",
        "click @ui.saveButton": "onSaveAndExit",
    },
    passwordView: null,
    scrollTop() {
        // Needs a slight delay because of the fade-in transition
        setTimeout(() => {
            $("html, body").animate({ scrollTop: ReviewStep.scrollPos }, 0);
            window.scrollTo(0, ReviewStep.scrollPos);
        }, 10);
    },
    showStep(event) {
        ReviewStep.scrollPos = document.body.scrollTop;

        event.preventDefault();
        const $item = $(event.currentTarget);
        this.trigger("step:load", $item.attr("data-step"));
        $(".application").addClass("review-editing");
        $(".review-button-container").hide();
        this.onDestroy();
    },
    render() {
        $(".next-container").hide();
        $(".application").removeClass("review-editing").addClass("review-step");

        // Skip the AJAX call
        if (this.options.noFetch) {
            Step.prototype.render.call(this);
            this.scrollTop();
            return;
        }

        // @TODO spinner
        const positions = window.positions.map((position) => position.id);

        $.ajax({
            type: "GET",
            url: `/api/hire/v1/profile/?p=${positions.join(",")}`,
            dataType: "json",
            contentType: "application/json",
        }).done((data) => {
            ReviewStep.data = data;
            Step.prototype.render.call(this);
            this.scrollTop();
        });
    },
    getNextButton() {
        return this.$(".next-button");
    },
    showPasswordAuth() {
        if (window.user.hasPassword) {
            this.submit();
            return false;
        }

        const $modal = this.$(".password-auth-modal")
            .clone()
            .modal({
                closeClass: "icon-close",
                closeText: "&times;",
                fadeDuration: 350,
                fadeDelay: 0,
            })
            .show();

        this.passwordView = new auth.SetPasswordView({
            el: $modal.find(".modal-content"),
            phone: window.user.phone,
            email: window.user.email,
            template: tmpl.ReviewAuth,
        });
        this.passwordView.render();

        $modal.find("button").on("click", this.submit.bind(this));

        return false;
    },
    postRender() {
        const $pwContainer = this.$(".password-container");
        if (window.user.hasPassword) {
            $pwContainer.remove();
            this.ui.reviewPWSection.addClass("no-pw-modal");
            this.ui.enterPW.remove();
        } else {
            $pwContainer.empty();
            this.passwordView = new auth.SetPasswordView({
                el: $pwContainer,
                phone: window.user.phone,
                email: window.user.email,
                template: tmpl.ReviewAuth,
            });
            this.passwordView.render();
        }

        // @TODO Probably gonna need to do something in the case the user comes back
        // @TODO and decides to pick "I have no work history", re: clearing out the reminder
        if (this.model.hasResumeReminder()) {
            const $body = $("body");
            $body.addClass("app-fixed-nav");

            $(".next-container").hide();
            $(".review-button-container").hide();

            // When we scroll past the reminder section, we highlight the button differently
            const height = this.ui.reminderSection[0].offsetHeight;

            $body.on(
                "scroll",
                _throttle(() => {
                    $("#save-exit-link").toggleClass(
                        "btn btn-primary btn-special",
                        document.body.scrollTop >= height,
                    );
                }, 20),
            );
        } else {
            $(".review-button-container")
                .show()
                .off("click")
                .on("click", this.showPasswordAuth.bind(this));
        }

        this.availComponent = new component.AvailabilityComponent({
            el: this.ui.avail,
            data: this.serializeData(),
            disabled: true,
        });
        this.availComponent.render();

        if (this.model.get("auto_apply_enabled") === null) {
            new component.AutoApply({
                el: this.ui.autoApplySection,
                handleAutoApplyChange: this.handleAutoApply.bind(this),
            }).render();
        } else {
            this.ui.autoApplySection.hide();
        }

        setTimeout(() => {
            this.getNextButton().fadeIn();
        }, 0);
    },
    handleAutoApply(enabled) {
        this.model.set("auto_apply_enabled", enabled);
    },
    serializeData() {
        const data = modelUtil.formatAppData(ReviewStep.data);
        data.resumeReminder = null;

        const reminder = this.model.getResumeReminder();
        if (reminder) {
            if (reminder === "skip") {
                data.resumeReminder = "skip";
            } else {
                const now = moment();

                let day = `on ${reminder.format("dddd")}`;
                if (reminder.isSame(now, "day")) {
                    day = "today";
                } else if (reminder.isSame(now.add(1, "day"), "day")) {
                    day = "tomorrow";
                }

                data.resumeReminder = `${reminder.format("h:mma")} ${day}`;
            }

            const query = qs.parse(window.location.search);
            delete query.from_sug;
            // br = bypass reminder
            query.br = 1;

            data.reminderLink = `${window.location.pathname}?${qs.stringify(query)}`;
        }

        return {
            ...data,
            LONG_ANSWER_CHARS,
        };
    },
    onSaveAndExit(event) {
        event.preventDefault();

        const finish = () => {
            if (this.model.isResumeReminderSkipped()) {
                this.model.trigger("app:reminder");
                return;
            }

            setTimeout(() => {
                window.location.href = "/";
            }, 0);
        };

        if (this.passwordView) {
            this.ui.saveButton.loading(true);
            this.submitPassword(finish, () => {
                this.ui.saveButton.loading(false);
            });
        } else {
            finish();
        }
    },
    onSaveAndRemind(event) {
        event.preventDefault();

        if (this.passwordView) {
            this.ui.remindButton.loading(true);

            // no-op on save 'cause we just want
            this.submitPassword(
                () => {},
                () => {
                    this.ui.remindButton.loading(false);
                },
            );
        }
    },
    onSubmit() {
        $(".review-button-container").hide();
        this.nextStep();
    },
    nextStep() {
        this.model.trigger("step:apply");
        $("body").removeClass("app-fixed-nav");
        this.onDestroy();
    },
    submitPassword(onDone, onAlways) {
        this.getNextButton().disable();
        const always = () => {
            this.getNextButton().enable();
            if (onAlways) {
                onAlways();
            }
        };

        const submitted = this.passwordView.submit();
        if (submitted !== false) {
            submitted.done(onDone).always(always);
        } else {
            always();
        }
    },
    submit() {
        if (this.passwordView) {
            this.submitPassword(this.onSubmit.bind(this));
            return false;
        }

        if (window.user.hasPassword) {
            this.onSubmit();
            return false;
        }

        return true;
    },
});
ReviewStep.scrollPos = 0;

export default {
    Address: AddressStep,
    Availability: AvailabilityStep,
    BasicInfo: BasicInfoStep,
    SignUp: SignUpStep,
    History: HistoryStep,
    Promo: PromoStep,
    Summary: SummaryStep,
    Review: ReviewStep,
    Suggestions: SuggestionsStep,
};
